/**
 * Clés localStorage dont la valeur n'a de sens que pour UN établissement ou
 * UNE session. Les oublier, c'est afficher la BI ou l'import de l'hôtel
 * précédent sous le nom du nouveau, ou retomber en silence, après une
 * reconnexion, sur le client qu'un super admin consultait.
 */
export const SELECTED_FACILITY_STORAGE_KEY = 'SELECTED_FACILITY_ID';

const FACILITY_SCOPED_KEYS = [
    'bi_facility_id',
    'triggerflow_reservation_import_job_id',
];

function removeKeys(keys: string[]): void {
    try {
        keys.forEach((key) => localStorage.removeItem(key));
    } catch {
        // Stockage indisponible (navigation privée stricte) : rien à nettoyer.
    }
}

/** À la bascule d'établissement. */
export function clearFacilityScopedStorage(): void {
    removeKeys(FACILITY_SCOPED_KEYS);
}

/** Au changement de jeton (connexion, SSO, « se connecter en tant que », 401). */
export function clearSessionScopedStorage(): void {
    removeKeys([SELECTED_FACILITY_STORAGE_KEY, ...FACILITY_SCOPED_KEYS]);
}
